import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Input, Label, Row, Col, Button } from 'reactstrap';
import NumberInput from '../controls/numberInput';
import TextInput from '../controls/textInput';
import { removeItemWithConfirm } from '../classes/handleItemWithConfirm';
import Icon from '../containers/icon';
const confirmOnRemoveFields = ['assetID', 'quantity', 'size', 'comment'];
const AssociatedAssetsItem = props => {
  const {
    index,
    onChange,
    asset,
    onRemove
  } = props;
  const handleChangeComment = event => onChange(index, 'comment', event.target.value);
  const handleChangeQuantity = value => onChange(index, 'quantity', value);
  const handleChangeSize = (name, value) => onChange(index, 'size', value);

  // this calls onRemove IFF either
  //   a) there is no asset to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the asset.
  const handleRemove = () => removeItemWithConfirm(asset, 'Associated Asset', confirmOnRemoveFields, onRemove.bind(null, index));
  return /*#__PURE__*/React.createElement("section", {
    className: `t-aai-${index}`
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Asset"), /*#__PURE__*/React.createElement(Input, {
    value: asset.name,
    placeholder: "Required",
    disabled: true
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "control-label",
    htmlFor: "remove-button"
  }, /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(Button, {
    id: "remove-button",
    size: "sm",
    onClick: handleRemove,
    className: "form-control t-asi-remove-associated-asset"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Entry")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "Quantity",
    value: asset.quantity,
    entity: "AssetAssociation",
    field: "quantity",
    onChange: handleChangeQuantity
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Size",
    field: "size",
    data: asset,
    onChange: handleChangeSize,
    entity: "AssetAssociation"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Comments"), /*#__PURE__*/React.createElement(Input, {
    type: "textarea",
    className: "t-aa-comments",
    onChange: handleChangeComment,
    style: {
      resize: 'vertical'
    },
    value: asset.comment || ''
  })))), /*#__PURE__*/React.createElement("hr", null));
};
AssociatedAssetsItem.propTypes = {
  asset: PropTypes.shape({
    comment: PropTypes.string,
    name: PropTypes.string,
    quantity: PropTypes.number
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default AssociatedAssetsItem;